module.exports = __webpack_public_path__ + "static/media/kooksCookMenu.90270e7f.pdf";